import { render, staticRenderFns } from "./ModernTimeDimensionsTab.vue?vue&type=template&id=4fd583e7"
import script from "./ModernTimeDimensionsTab.vue?vue&type=script&lang=js"
export * from "./ModernTimeDimensionsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports